var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "shape-link",
      attrs: { href: "/participants-page" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.changeRoute("/participants-page")
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "about-category__inner" },
        [
          _vm.item.caption
            ? _c("BaseCaption", { attrs: { text: _vm.item.caption } })
            : _vm._e(),
          _vm.item.descr
            ? _c("BaseText", { attrs: { text: _vm.item.descr } })
            : _vm._e(),
          _c("ShapeNumberItem", {
            attrs: { index: _vm.index, src: "link-number" }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78f832ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78f832ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/ShapeListLink.vue
// module id = I1w8
// module chunks = 2